<template>
  <div class="categories-widget margint20 card card-padding">
    <div class="title-line">
      <h5 class="sidebar-title">{{ title }}</h5>
      <hr />
    </div>
    <ul class="list-style-2 list-style">
      <li v-for="(item, i) in list" :key="i">
        <a :href="item.url">{{ item.label }}</a>
      </li>
    </ul>
  </div>
</template>
<script setup>
import { defineProps, computed } from "vue"
import i18n from "@/i18n"

const props = defineProps({
  type: {
    type: String,
    default: "support",
    validator(val) {
      return ["support", "companyInfo"].includes(val)
    }
  }
})

const title = computed(() => (props.type === "companyInfo" ? i18n.t("footer.fot2") : i18n.t("common.support")))
const list = computed(() =>
  props.type === "companyInfo"
    ? [
        { label: i18n.t("footer.fot3"), url: "/About" },
        { label: i18n.t("footer.fot4"), url: "/Subsidiaries" },
        { label: i18n.t("footer.fot5"), url: "/Factory" },
        { label: i18n.t("footer.fot6"), url: "/Certificates" },
        { label: i18n.t("footer.fot7"), url: "/Articles" },
        { label: i18n.t("footer.fot8"), url: "/Careers" },
        { label: i18n.t("footer.fot9"), url: "/Feedback" }
      ]
    : [
        { label: i18n.t("footer.fot11"), url: "/Contact" },
        { label: i18n.t("footer.fot12"), url: "/Services" },
        { label: i18n.t("footer.fot13"), url: "/FAQ" },
        { label: i18n.t("footer.fot14"), url: "/Returns" },
        { label: i18n.t("footer.fot15"), url: "/Delivery" },
        { label: i18n.t("footer.fot16"), url: "https://forms.zohopublic.com/midonkey/form/RegisterYourEbike/formperma/T6dLCCvn14DX1ahGeBmI4Ml7blRhPEGzSkHqb7xX9Y0" },
        { label: i18n.t("footer.fot17"), url: "/Warranty" },
        { label: i18n.t("footer.fot18"), url: "/Catalogues" },
        { label: i18n.t("footer.fot19"), url: "/Guides" },
        { label: i18n.t("footer.fot20"), url: "https://zcmpsub.maillist-manage.com/ua/Optin?od=11287ecbcf7dfb&amp;zx=12dbb92e1&amp;sD=1c6b0bde3735056d" },
        { label: i18n.t("footer.fot21"), url: "/Recycling" }
      ]
)
</script>
